<script>
import { mapState } from 'vuex'
import { MemberForm } from '@src/forms/Property'
import Request from '@src/mixins/request'

export default {
  mixins: [Request],

  props: {
    name: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      form: {},
      benefits: '',
    }
  },

  computed: {
    ...mapState('app', ['currentProperty']),
  },

  mounted() {
    this.form = new MemberForm(this.$route.params.property)
  },

  methods: {
    onSubmit() {
      this.updateData({
        url: this.endpoint.property.updateMember,
        data: {
          id: this.currentProperty.id,
          update: this.form,
        },
      })
    },
    addValue() {
      this.form.benefits.push(this.benefits)
      this.benefits = ''
    },
    removeValue(index) {
      this.form.benefits.splice(index, 1)
    },
  },
}
</script>

<template>
  <VForm @submit.prevent="onSubmit">
    <BaseCard>
      <BaseControlInput label="Discount amount">
        <VTextField
          v-model="form.percentDiscount"
          label="Discount amount"
          color="gold"
          suffix="%"
        />
      </BaseControlInput>

      <BaseControlInput label="1 point equals to">
        <VTextField
          v-model="form.pointValue"
          label="1 point equals to"
          color="gold"
          prefix="USD"
        />
      </BaseControlInput>

      <BaseControlInput label="Benefits">
        <VTextField
          v-model="benefits"
          label="Benefits"
          color="gold"
          append-outer-icon="add"
          hide-details
          @click:append-outer="addValue"
        />
        <VTextField
          v-for="(value, index) in form.benefits"
          :key="index"
          v-model="form.benefits[index]"
          color="gold"
          append-outer-icon="clear"
          hide-details
          @click:append-outer="removeValue(index)"
        />
      </BaseControlInput>

      <VBtn
        slot="card-actions-right"
        color="gold"
        type="submit"
        :loading="loading"
        dark
      >
        Update
      </VBtn>
    </BaseCard>
  </VForm>
</template>
